import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import DownloadFile from '@/core/utils/DownloadFile'

export default {
	async [actionTypes.DOCUMENTOS.BUSCAR_POR_FILTRO]({ state }) {
		const { filtro, paginacao, idAta } = state

		const { data } = await api.documentos.buscarDocumentosPorFiltro(filtro, paginacao, idAta)
		return data
	},

	async [actionTypes.DOCUMENTOS.BAIXAR_DOCUMENTO]({ state }, idDocumento) {
		const response = await api.documentos.baixar(idDocumento)
		const headers = response.headers

		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
}
